import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    unreadNotifications: [],
    unread: 0
}

const notificationsSlice = createSlice({
    name: 'notifications',
    initialState,
    reducers: {
        setUnreadNotification(state, action) {
            state.unreadNotifications = action.payload.list.filter(n => n.status === 'unread');
            state.unread = action.payload.count;
        },
        updateNotificationStatus(state, action) {
            const updatedNotifications = state.unreadNotifications.filter(n => n._id !== action.payload.id);
            state.unreadNotifications = updatedNotifications;
            state.unread = action.payload.count;
        }
    }
});

export const { setUnreadNotification, updateNotificationStatus } = notificationsSlice.actions;

export default notificationsSlice.reducer;
